import gql from "graphql-tag";

export default gql`
  query getLuOakTranche {
    getLuOakTranche {
      __typename
      code
      code_parent
      name
      level
      description
      path
      depth
    }
  }
`;
